import { Component, OnInit } from '@angular/core';
import { MsalService,MsalBroadcastService  } from '@azure/msal-angular';
import { EventMessage, EventType, AuthenticationResult } from '@azure/msal-browser';
import { Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import {
  SessionService,
  UtilityService
} from '@cs/core-data';
import { environment } from '../environments/environment';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@cs/material';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { Observable } from 'rxjs';
@Component({
  selector: 'cs-root',
  standalone: true,
  imports:[RouterModule,CommonModule,MaterialModule,LoadingBarModule],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  title = 'Campaign Studio';
  tmpDealersArr = [];
  isLoading$: Observable<boolean> = this.utilityService.loading$;
constructor(
  private readonly msalService: MsalService, 
  private readonly router: Router,
  private readonly msalBroadcastService: MsalBroadcastService,
  private readonly sessionService: SessionService,
  private readonly utilityService: UtilityService
  ) {}

  ngOnInit(): void {
    console.log('from appc comp');
    // 1. Handle the redirect flow (critical for Redirect logins)
    this.msalService.handleRedirectObservable().subscribe();

    // 2. Set active account after a successful login
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
      )
      .subscribe((result: EventMessage) => {
        const payload = result.payload as AuthenticationResult;
        this.msalService.instance.setActiveAccount(payload.account);        
      });
      this.checkAndSetActiveAccount();
    
  }

  checkAndSetActiveAccount() {
    const currentPath = globalThis.location.pathname;
    let activeAccount = this.msalService.instance.getActiveAccount();

    if (!activeAccount && this.msalService.instance.getAllAccounts().length > 0) {
      const accounts = this.msalService.instance.getAllAccounts();
      this.msalService.instance.setActiveAccount(accounts[0]);
      activeAccount = accounts[0];

      console.log(activeAccount);
        this.sessionService
          .login(activeAccount['username'].split('@')[0].toLowerCase(), environment)
          .subscribe(data => {
            if (currentPath === '/' || currentPath === '') {
              this.router.navigate(['/main']);
            } else {
              console.log('Staying on current path:', currentPath);
              // Do NOTHING here. Let the Angular Router handle the deep link.
            }
          },
        (error) =>{
          console.error('Login error or Access Denied:', error);
          this.router.navigate(['/access-denied']);
        });
    }
  }

getDealerData(data: any) {
    if (data) {
      data.forEach(element => {
        this.utilityService
          .getDealersData(environment, element.pacode)
          .subscribe(dealersData => {
            element.friendly_name = dealersData[0].friendly_name;
            element.account_number = dealersData[0].account_number;
            element.region = dealersData[0].region;

            this.dealersTable(element);
          });
      });
    }
  }

  dealersTable(dealersData) {
    if (dealersData) {
      this.tmpDealersArr = this.tmpDealersArr.concat(dealersData);
      localStorage.setItem('userDealers', JSON.stringify(this.tmpDealersArr));
    }
  }

  login() {
    this.msalService.loginRedirect();
  }

  logout() {
    this.msalService.logoutRedirect({ postLogoutRedirectUri: '/' });
  }
}